import axios from "axios";
import { IInvoiceModel } from "./InvoiceModel";
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const INVOICE_CREATE_URL = `${API_URL}api/v1/invoice/create`;
export function createInvoice(invoice: IInvoiceModel) {
  return axios.post(INVOICE_CREATE_URL, invoice)
}




